<template>
  <div v-if="team">
    <div class="card-sakali">
      <div class="d-block row my-auto mx-4 text-center">
        Härte
        <vue-slider
            v-model="team.aggression"
            :min="1"
            :max="10"
            tooltip="always"
            :lazy="true"/>
      </div>
      <hr>
      <div class="row mt-4">
        <div class="col-12 mb-1 text-center">Motivation</div>
        <div class="col-12 px-4">
          <div class="progress p-0 border-sakali-primary">
            <div class="progress-bar bg-sakali-primary text-dark" role="progressbar"
                 :style="{width: motivationPercentage + '%'}"
                 aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
              {{ team.motivation | float }}
            </div>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center">
          <div class="my-auto pe-2" v-if="team.motivation < 10">Handgeld:</div>
          <div class="m-1" v-if="2500 < maxInvest">
            <button class="btn btn-sakali btn-sm"
                    @click="investIntoMotivation(2500)">
              {{ 2500 | kies }}
            </button>
          </div>
          <div class="m-1" v-if="5000 < maxInvest">
            <button class="btn btn-sakali btn-sm"
                    @click="investIntoMotivation(5000)">
              {{ 5000 | kies }}
            </button>
          </div>
          <div class="m-1" v-if="maxInvest > 0">
            <button class="btn btn-sakali btn-sm"
                    @click="investIntoMotivation(maxInvest)">
              {{ maxInvest | kies }}
            </button>
          </div>
          <div class="m-1" v-else>
            <span v-if="team.motivation == 10">Volle Motivation erreicht.</span>
            <span v-else>Du hast kein Kies mehr.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sakaliApi from '../../sakali-api'
import {mapActions, mapGetters} from 'vuex'
import VueSlider from 'vue-slider-component'

export default {
  props: {
    team: Object
  },
  computed: {
    ...mapGetters(['user', 'loggedIn']),
    aggression() {
      return this.team.aggression
    },
    maxInvest() {
      return Math.min((10 - this.team.motivation) * 5000,
          this.loggedIn ? this.user.balance : 0)
    },
    motivationPercentage() {
      return this.team.motivation / 10 * 100
    }
  },
  methods: {
    ...mapActions(['handleErrorAction', 'refreshUserAction']),
    updateAggression() {
      let kv = {
        key: 'aggression',
        value: this.aggression
      }
      sakaliApi.post('/teams/' + this.team.id + '/aggression', kv)
          .catch(error => {
            this.handleErrorAction(error)
          })
    },
    investIntoMotivation(amount) {
      sakaliApi.post('/teams/' + this.team.id + '/motivation', {
        key: 'motivation',
        value: amount
      }).then(() => {
        this.refreshUserAction()
        this.$emit("update:team")
      }).catch(error => {
        this.handleErrorAction(error)
      })
    }
  },
  watch: {
    aggression(newValue, oldValue) {
      if (!oldValue || (oldValue == newValue))
        return
      this.updateAggression()
    },
  },
  components: {
    VueSlider
  }
}
</script>

<style>

.vue-slider-dot-handle {
  background-color: #fda642;
  border: 2px solid white;
}

.vue-slider-process {
  background-color: #fda642;
}

.vue-slider-dot-tooltip-inner {
  color: #fda642;
}

</style>
